import SmartExchangeManager from '@/manager/2.6/SmartExchangeManager';
import IFeedData from '@/models/comp/IFeedData';
import SmartExchangeRequest from '@/models/requests/SmartExchangeRequest';
import CompDataFeedsRequest from '../models/CompDataFeedsRequest';

export default {
    /**
     * Fetches smart exchange records within the store. Currently delegates to the SmartExchangeManager.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param request
     * @returns
     */
    async fetch(request: SmartExchangeRequest): Promise<IFeedData> {
        const feedData = await SmartExchangeManager.fetchFeedData(request);
        return feedData;
    },

    async fetchFeedDataSubComps(feedRequest: CompDataFeedsRequest): Promise<void> {
        await SmartExchangeManager.fetchFeedDataSubComps(feedRequest);
    },
};
